import { CONTENTFUL_ROOT_CONTENT_TYPE } from '../../lib/constants';
import { fetchFirstContent } from '../../lib/services/contentful';
import { DispatchThunkAny } from '../../types/redux';

export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS';

export function fetchContent(): any {
	return async (dispatch: DispatchThunkAny) => {
		try {
			const data = await fetchFirstContent(CONTENTFUL_ROOT_CONTENT_TYPE);
			dispatch({ type: FETCH_CONTENT_SUCCESS, payload: data });
		} catch (error) {
			console.error('Cannot fetch content', error);
		}
	};
}
